import { render, staticRenderFns } from "./MySendings.vue?vue&type=template&id=4cb31d44"
import script from "./MySendings.vue?vue&type=script&lang=js"
export * from "./MySendings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports